import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import useTable from "../components/useTable";
import { baseUrl } from "../config/const";

export default function WaSalesDashboard() {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};


const [startDate, setStartDate] = useState(
  formatLocalDate(firstDay)
);

const [endDate, setEndDate] = useState(
  formatLocalDate(today)
);
  const [store, setStore] = useState("");
  const [data, setData] = useState(null);

  const fetchData = async () => {
    const query = new URLSearchParams({
      start: startDate,
      end: endDate,
      ...(store && { store })
    });

    const res = await fetch(
      `${baseUrl}/getwasalestoko?${query}`
    );
    const json = await res.json();
    setData(json);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const headCells = [
    { id: "rank", label: "Rank", disableSorting: true },
    { id: "koleksi", label: "Koleksi" },
    { id: "total_qty", label: "Qty" },
    { id: "total_revenue", label: "Revenue" },
    { id: "contribution_percentage_qty", label: "% Qty" },
  ];

    const headCellsSku = [
    { id: "rank", label: "Rank", disableSorting: true },
    { id: "Kode", label: "Koleksi" },
    { id: "total_qty", label: "Qty" },
    { id: "total_revenue", label: "Revenue" },
    { id: "contribution_percentage_qty", label: "% Qty" },
  ];

  const records =
    data?.list_koleksi_laku.map((item, index) => ({
      id: index,
      rank: index + 1,
      ...item,
    })) || [];

    const skuRecords =
      data?.list_barang_laku.map((item, index) => ({
        id: index,
        rank: index + 1,
        ...item,
      })) || [];

  const filterFn = { fn: (items) => items };

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    styledTableCell : TableCell,
  } = useTable(records, headCells, filterFn);

    const filterFnSku = { fn: (items) => items };
    const {
      TblContainer: TblContainerSku,
      TblHead: TblHeadSku,
      TblPagination: TblPaginationSku,
      recordsAfterPagingAndSorting: recordsAfterPagingAndSortingSku,
      styledTableCell: StyledTableCellSku,
    } = useTable(skuRecords, headCellsSku, filterFnSku);

  if (!data) return null;

  return (
    <Container maxWidth="lg" style={{ marginTop: 30 }}>
      <Typography variant="h6" gutterBottom>
        WA Sales Dashboard
      </Typography>

      {/* FILTER */}
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <TextField
            label="Start"
            type="date"
            size="small"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item>
          <TextField
            label="End"
            type="date"
            size="small"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item>
          <TextField
            select
            label="Store"
            size="small"
            value={store}
            onChange={(e) => setStore(e.target.value)}
            style={{ minWidth: 120 }}
          >
            <MenuItem value="">All</MenuItem>
            {data.store_options.map((s, i) => (
              <MenuItem key={i} value={s}>
                {s}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={fetchData}
          >
            Apply
          </Button>
        </Grid>
      </Grid>

      {/* KPI */}
      <Grid container spacing={2} style={{ marginTop: 20 }}>
        <Kpi title="Total WA Revenue" value={`Rp ${data.total_wa_revenue.toLocaleString()}`} />
        <Kpi title="WA Orders" value={data.wa_orders} />
        <Kpi
          title="WA Growth"
          value={`${data.wa_growth_percentage}%`}
          color={data.wa_growth_percentage >= 0 ? "green" : "red"}
        />
        <Kpi title="Total SKU Laku" value={data.list_barang_laku.length} />
      </Grid>

      {/* TABLE */}
      <div style={{ marginTop: 30 }}>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordsAfterPagingAndSorting().map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{item.rank}</TableCell>
                <TableCell>{item.koleksi}</TableCell>
                <TableCell>{item.total_qty}</TableCell>
                <TableCell>
                  Rp {item.total_revenue.toLocaleString()}
                </TableCell>
                <TableCell>
                  {item.contribution_percentage_qty}%
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
      </div>

        {/* SKU TABLE */}
        <div style={{ marginTop: 40 }}>
          <Typography variant="subtitle1" gutterBottom>
            SKU / Produk Laku
          </Typography>

          <TblContainerSku>
            <TblHeadSku />
            <TableBody>
              {recordsAfterPagingAndSortingSku().map((item) => (
                <TableRow key={item.id}>
                  <StyledTableCellSku>{item.rank}</StyledTableCellSku>
                  <StyledTableCellSku>{item.kode}</StyledTableCellSku>
                  <StyledTableCellSku>{item.total_qty}</StyledTableCellSku>
                  <StyledTableCellSku>
                    Rp {item.total_revenue.toLocaleString()}
                  </StyledTableCellSku>
                  <StyledTableCellSku>
                    {item.contribution_percentage_qty}%
                  </StyledTableCellSku>
                </TableRow>
              ))}
            </TableBody>
          </TblContainerSku>
          
          <TblPaginationSku />
        </div>      
    </Container>
  );

  
}

function Kpi({ title, value, color }) {
  return (
    <Grid item xs={12} sm={3}>
      <Card>
        <CardContent>
          <Typography variant="body2" color="textSecondary">
            {title}
          </Typography>
          <Typography
            variant="h6"
            style={{ color: color || "inherit" }}
          >
            {value}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}